import './App.css'
import Routes from './Routes'

export default function App() {

  return (
    <div className="App">
      <Routes />
    </div>
  )
}